import React, { useEffect } from 'react';
import { Switch, useHistory } from 'react-router-dom';
import { usePropertyProgress } from '../../contextsProperty/ContextProperties';
import PropertyPresentation from './propertyPresentation/PropertyPresentation';
import HeaderYourProperty from './HeaderYourProperty';
import FooterYourProperty from './FooterYourProperty';
import ProtectedRoute from '../../../utils/ProtectedRoute';
import MainInfo from './mainInfo/MainInfo';
import Description from './description/Description';
import SingleRoom from './roomsConfiguration/SingleRoom';
import RoomList from './propertyPresentation/completedPresentation/roomList/RoomList';
import {
    tabsData,
    URL_ID_KEY,
    URL_ROOM_ID_KEY,
    URL_TAB_PARAM,
} from '../../../utils/property/propertyUtils';
import { decodeBase64 } from '../../../utils/encodeBase64';
import { URL_STEP } from '../../../types/properties/propertyTypes';
import '../../../stylesheets/stylesLayout/yourPropertyDetail.scss';

const YourSingleProperty = () => {
    const { handleProgress, progressByStep, activeStep } =
        usePropertyProgress();

    const history = useHistory();
    const tabUrl = new URLSearchParams(history.location.search).get('tab');
    useEffect(() => {
        const [, , , urlStep] = history.location.pathname.split('/');
        let tabNumber = tabUrl ? Number(decodeBase64(tabUrl)) : 0;
        const targetStep = Object.values(tabsData).find(
            _tab => _tab.url === urlStep
        );

        const targetTab = targetStep?.tabs?.find(
            _tab => _tab.tabNumber === tabNumber
        );

        const lastTabCompleted =
            progressByStep?.[targetStep?.name]?.lastTabCompleted || 1;

        if (lastTabCompleted < tabNumber) {
            history.push(URL_TAB_PARAM(lastTabCompleted));
        } else {
            handleProgress(targetStep?.name, targetTab);
        }
    }, [location.pathname, tabUrl]);

    return (
        <>
            <HeaderYourProperty />
            <div className={`main__your-properties `}>
                <div className='flex flex-column flex-grow flex-justify-center flex-align-center width100perc min-height100perc'>
                    <Switch>
                        <ProtectedRoute
                            path={`/your-property/:${URL_ID_KEY}/${URL_STEP.MAIN_INFORMATION}`}
                            render={() => <MainInfo />}
                        />
                        <ProtectedRoute
                            path={`/your-property/:${URL_ID_KEY}/${URL_STEP.PUBLIC_PORTRAIT}`}
                            render={() => <Description />}
                        />
                        <ProtectedRoute
                            path={`/your-property/:${URL_ID_KEY}/${URL_STEP.ROOM_CONFIGURATION}/:${URL_ROOM_ID_KEY}`}
                            render={() => <SingleRoom />}
                        />
                        <ProtectedRoute
                            path={`/your-property/:${URL_ID_KEY}/${URL_STEP.ROOM_CONFIGURATION}`}
                            render={() => (
                                <div className='property-page__content'>
                                    <RoomList />
                                </div>
                            )}
                        />
                        <ProtectedRoute
                            path={`/your-property/:${URL_ID_KEY}`}
                            render={() => <PropertyPresentation />}
                        />
                    </Switch>
                </div>
            </div>
            {activeStep && <FooterYourProperty />}
        </>
    );
};

export default YourSingleProperty;
